import { render } from "./SectionFour.vue?vue&type=template&id=6a4f7fa4&scoped=true"
import script from "./SectionFour.vue?vue&type=script&lang=js"
export * from "./SectionFour.vue?vue&type=script&lang=js"

import "./SectionFour.vue?vue&type=style&index=0&id=6a4f7fa4&lang=css&scoped=true"

import exportComponent from "/Users/konradfigura/Developer/first-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4f7fa4"]])

export default __exports__